import React from 'react';
import styled from 'styled-components/macro';
import InfoBoxTable from './InfoBoxTable';


const InfoBoxArea = ({ areaData, roomData }) => {
    return (
        <Container>
            <TopArea>
                <Heading className="h6">Area</Heading>

                <InfoBoxTable data={areaData} showTotal={true} />
            </TopArea>

            <BottomArea>
                <InfoBoxTable data={roomData} />
            </BottomArea>
        </Container>
    );
};


export default InfoBoxArea;


const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2rem;
    margin: auto 0;
`;

const TopArea = styled.div`
    display: flex;
    flex-direction: column;
`;

const Heading = styled.div`
    color: ${props => props.theme.secondary_color};
`;

const BottomArea = styled.div`

`;

